/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'
import {
  Button,
  Icon,
  Grid,
  Card,
  CardContent,
  GridColumn,
  Modal,
  Dropdown,
} from 'semantic-ui-react'
import Swal from 'sweetalert2'
import { CustomerViewContext } from '../customer-info-view/customerView'
import IntelMsg from '../../../ItelMsg'
import styles from './customerHierarchy.module.css'
import { primaryColor } from '../../../../constants'
import AddZoneModal from './addZoneModal'
import AddRegionModal from './addRegionModal'
import AddSiteModal from './addSiteModal'
import AssetsBulkUpload from '../../../tank/bulk-upload/bulkAssets.components'
import TreeHierarchy from './adminTreeHierarchy'
import {
  GetSitesWithMoreThanDevice,
  GetSiteDevices,
  SetMasterDevice,
} from '../../../../services/asset'

const hrStyle = {
  border: '0',
  clear: 'both',
  display: 'block',
  width: '100%',
  backgroundColor: '#000',
  height: '1px',
}

function modalReducer(state, action) {
  switch (action.type) {
    case 'OPEN_MODAL':
      return { open: true, dimmer: action.dimmer }
    case 'CLOSE_MODAL':
      return { open: false }
    default:
      throw new Error()
  }
}

const CustomerHierarchy = () => {
  const [state, dispatch] = React.useReducer(modalReducer, {
    open: false,
    dimmer: undefined,
  })
  const { setViewHierarchy } = useContext(CustomerViewContext)
  const { customerSettings } = useContext(CustomerViewContext)
  const { open, dimmer } = state
  const [sitesList, setSitesList] = useState([])
  const [options, setOptions] = useState([])
  const [devicesList, setDevicesList] = useState([])
  const [deviceOptions, setDeviceOptions] = useState([])
  const [masterData, setMasterData] = useState({})
  const [modals, setModals] = useState({
    zone: false,
    region: false,
    site: false,
    bulk: false,
  })
  const [productName, setProductName] = useState('')

  useEffect(() => {
    setProductName(localStorage.getItem('product'))
  }, [])

  const openModal = (key) => {
    setModals((prevState) => ({ ...prevState, [key]: true }))
  }

  useEffect(() => {
    const newOptions = sitesList.map((item) => ({
      key: item.id,
      text: item.label || item.name,
      value: `${item.id},${item.name}`,
    }))
    setOptions(newOptions)
  }, [sitesList])

  useEffect(() => {
    const newOptions = devicesList.map((item) => ({
      key: item.id,
      text: item.label || item.name,
      value: `${item.id},${item.name}`,
    }))
    setDeviceOptions(newOptions)
  }, [devicesList])

  const handleMasterModal = (e) => {
    e.preventDefault()
    GetSitesWithMoreThanDevice(customerSettings.tbCustomerId).then((data) => {
      setSitesList(data || [])
    })
    dispatch({ type: 'OPEN_MODAL' })
  }

  const handleSiteSelect = (e, { value }) => {
    const [id, name] = value.split(',')
    setDevicesList([...devicesList, { siteId: id }])
    GetSiteDevices(id, 'site').then((data) => {
      setMasterData({ siteName: name, siteId: id, devices: [...data] })
      setDevicesList(data || [])
    })
  }

  const handleCancelModal = () => {
    dispatch({ type: 'CLOSE_MODAL' })
  }

  const handleDeviceSelect = (e, { value }) => {
    const [id, name] = value.split(',')
    setMasterData((prevState) => ({
      ...prevState,
      masterId: id,
      siteId: prevState.siteId,
      devices: [...prevState.devices],
    }))
  }

  const submitMaster = () => {
    console.log('submitted: ', masterData)
    Swal.showLoading()
    SetMasterDevice(masterData)
      .then((res) => {
        Swal.fire({
          title: 'Device Updated Successfully!',
          confirmButtonColor: 'Green',
          icon: 'success',
        })
        dispatch({ type: 'CLOSE_MODAL' })
      })
      .catch((e) => {
        Swal.fire({
          title: 'Error Updating Device!',
          confirmButtonColor: 'Red',
          icon: 'error',
        })
        dispatch({ type: 'CLOSE_MODAL' })
      })
  }
  const getOpenState = (key, value) => {
    setModals((prevState) => ({ ...prevState, [key]: value }))
  }
  return (
    <>
      {productName !== 'cold' && (
        <>
          <div className={styles.container}>
            <IntelMsg id="customerHierarchy" />
          </div>
          <h3
            style={{
              backgroundColor: '#4B6587',
              padding: '10px',
              color: '#FFF',
              textAlign: 'center',
            }}
          >
            Add Hierarchy Level
          </h3>
          <br />
        </>
      )}

      <Grid>
        <Grid.Row columns={productName === 'cold' ? 3 : 5}>
          <Grid.Column
            style={{
              width: 'fit-content !important',
              textAlign: '-webkit-center',
            }}
          >
            <Card
              className={styles.card}
              style={{
                width: 'fit-content !important',
                backgroundColor: '#303d54',
                color: '#FFF',
                fontWeight: 'bold',
              }}
              onClick={() => openModal('zone')}
            >
              <CardContent>
                Level 1 (Top Level) <Icon name="plus circle" />
              </CardContent>
            </Card>
          </Grid.Column>
          <Grid.Column
            style={{
              width: 'fit-content !important',
              textAlign: '-webkit-center',
            }}
          >
            <Card
              className={styles.card}
              style={{
                width: 'fit-content !important',
                backgroundColor: '#303d54',
                color: '#FFF',
                fontWeight: 'bold',
              }}
              onClick={() => openModal('region')}
            >
              <CardContent>
                Level 2 <Icon name="plus circle" />
              </CardContent>
            </Card>
          </Grid.Column>
          <Grid.Column
            style={{
              width: 'fit-content !important',
              textAlign: '-webkit-center',
            }}
          >
            <Card
              className={styles.card}
              style={{
                width: 'fit-content !important',
                backgroundColor: '#303d54',
                color: '#FFF',
                fontWeight: 'bold',
              }}
              onClick={() => openModal('site')}
            >
              <CardContent>
                Level 3 <Icon name="plus circle" />
              </CardContent>
            </Card>
          </Grid.Column>
          {productName !== 'cold' && (
            <GridColumn>
              <Card
                style={{
                  backgroundColor: '#303d54',
                  color: '#FFF',
                  fontWeight: 'bold',
                }}
                className={styles.card}
                onClick={() => openModal('bulk')}
              >
                <CardContent>
                  Bulk Upload <Icon name="plus circle" />
                </CardContent>
              </Card>
            </GridColumn>
          )}
          {productName !== 'cold' && (
            <GridColumn>
              <Card
                style={{
                  backgroundColor: '#303d54',
                  color: '#FFF',
                  fontWeight: 'bold',
                }}
                className={styles.card}
                onClick={handleMasterModal}
              >
                <CardContent>
                  Master/Slave <Icon name="settings" />
                </CardContent>
              </Card>
            </GridColumn>
          )}
        </Grid.Row>
      </Grid>
      <br />

      {productName === 'tank' && (
        <>
          <hr style={{ ...hrStyle }} />

          <TreeHierarchy />
          <div className={styles.actions}>
            <Button
              form="customerSettings"
              type="submit"
              style={{ backgroundColor: primaryColor, color: 'white' }}
              onClick={() => setViewHierarchy(false)}
            >
              <Icon name="arrow left" />
              <IntelMsg id="back" />
            </Button>
          </div>
        </>
      )}

      <Modal
        dimmer={dimmer}
        open={open}
        onClose={() => {
          setDevicesList([])
          dispatch({ type: 'CLOSE_MODAL' })
        }}
      >
        <Modal.Header style={{ backgroundColor: '#2185d0', color: 'white' }}>
          Master/Slave
        </Modal.Header>
        <Modal.Content>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>
                <span style={{ color: 'black' }}>Select Site: </span>
                <Dropdown
                  name="siteName"
                  onChange={handleSiteSelect}
                  options={options}
                  selection
                  placeholder="select site"
                  search
                />
              </Grid.Column>
              <Grid.Column>
                <span style={{ color: 'black' }}>Select Master Device: </span>
                <Dropdown
                  onChange={handleDeviceSelect}
                  options={deviceOptions}
                  selection
                  placeholder="select device"
                  search
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button
            style={{ backgroundColor: 'green', color: 'white' }}
            onClick={submitMaster}
          >
            Submit
          </Button>
          <Button onClick={handleCancelModal}>Cancel</Button>
        </Modal.Actions>
      </Modal>

      <AddZoneModal open={modals.zone} getOpenState={getOpenState} />
      <AddRegionModal open={modals.region} getOpenState={getOpenState} />
      <AddSiteModal open={modals.site} getOpenState={getOpenState} />
      <AssetsBulkUpload open={modals.bulk} getOpenState={getOpenState} />
    </>
  )
}

export default CustomerHierarchy
